module.exports = __webpack_public_path__ + "img/07-white.4cfb6f24.svg";